module.exports = __webpack_public_path__ + "assets/img/00025.101f1949.png";